import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import Load from "../Loading/Load";
import "./modern-forms.css";
import axios from "axios";

function ModernContactInfo() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  
  // Permanent address fields
  const [address, setAddress] = useState("");
  const [address1, setAddress1] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  
  // Current address fields
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [city1, setCity1] = useState("");
  const [state1, setState1] = useState("");
  const [country1, setCountry1] = useState("");
  const [sameAddress, setSameAddress] = useState(false);
  
  // For location dropdowns
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  
  // For second address location dropdowns
  const [states1, setStates1] = useState([]);
  const [cities1, setCities1] = useState([]);
  const [selectedCountry1, setSelectedCountry1] = useState("");
  const [selectedState1, setSelectedState1] = useState("");

  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 2;

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;
  
  // Fetch countries, states, and cities
  const fetchData = (url, successCallback) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
        successCallback(sortedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        alert("Something went wrong while fetching data. Please try again.");
      });
  };

  useEffect(() => {
    fetchData(`${API_BASE_URL}/api/countries`, setCountries);
  }, []);

  const handleCountryChange = (event, isSecondAddress = false) => {
    const selectedCountryId = event.target.value;
    
    if (isSecondAddress) {
      setSelectedCountry1(selectedCountryId);
      fetchData(`${API_BASE_URL}/api/states/${selectedCountryId}`, setStates1);
    } else {
      setSelectedCountry(selectedCountryId);
      fetchData(`${API_BASE_URL}/api/states/${selectedCountryId}`, setStates);
    }
  };

  const handleStateChange = (event, isSecondAddress = false) => {
    const selectedStateId = event.target.value;
    
    if (isSecondAddress) {
      setSelectedState1(selectedStateId);
      fetchData(`${API_BASE_URL}/api/cities/${selectedStateId}`, setCities1);
    } else {
      setSelectedState(selectedStateId);
      fetchData(`${API_BASE_URL}/api/cities/${selectedStateId}`, setCities);
    }
  };

  const handleCheckboxChange = () => {
    setSameAddress(!sameAddress);
    if (!sameAddress) {
      // Copy values from current address to permanent address
      setAddress2(address);
      setAddress3(address1);
      setCity1(city);
      setState1(state);
      setCountry1(country);
      setSelectedCountry1(selectedCountry);
      setSelectedState1(selectedState);
      
      // Fetch the states and cities data for the permanent address
      if (selectedCountry) {
        fetchData(`${API_BASE_URL}/api/states/${selectedCountry}`, setStates1);
      }
      if (selectedState) {
        fetchData(`${API_BASE_URL}/api/cities/${selectedState}`, setCities1);
      }
    } else {
      setAddress2("");
      setAddress3("");
      setCity1("");
      setState1("");
      setCountry1("");
      setSelectedCountry1("");
      setSelectedState1("");
      setCities1([]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/Contact`,
        {
          user,
          address,
          address1,
          city,
          state,
          country,
          address2,
          address3,
          city1,
          state1,
          country1,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      console.log("API Response:", response.data);

      if (response.data.auth) {
        setLoading(false);
        navigate("/modern-personal-info", { replace: true });
        
        // Reset form fields
        setAddress("");
        setAddress1("");
        setCity("");
        setState("");
        setCountry("");
        setAddress2("");
        setAddress3("");
        setCity1("");
        setState1("");
        setCountry1("");
      } else {
        setLoading(false);
        alert("Error: " + (response.data.message || "Failed to save contact information"));
      }
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
      alert("Error: " + (error.response?.data?.message || error.message || "Failed to save contact information"));
    }
  };

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "\u2713" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Contact Details</h2>
          <p className="profile-form-subtitle">Tell us where you live</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-section-title">Permanent Address</div>
            
            <div className="form-group">
              <label className="form-label">Address Line 1</label>
              <input
                className="form-control"
                type="text"
                value={address}
                placeholder="Enter your house details"
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Address Line 2</label>
              <input
                className="form-control"
                type="text"
                value={address1}
                placeholder="Enter village or area name"
                onChange={(e) => setAddress1(e.target.value)}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Country</label>
                  <select
                    className="form-control"
                    value={country}
                    onChange={(e) => {
                      setCountry(e.target.value);
                      handleCountryChange(e, false);
                    }}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">State</label>
                  <select
                    className="form-control"
                    value={state}
                    onChange={(e) => {
                      setState(e.target.value);
                      handleStateChange(e, false);
                    }}
                    disabled={!selectedCountry}
                    required
                  >
                    <option value="">Select State</option>
                    {states.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">City</label>
              <select
                className="form-control"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                disabled={!selectedState}
                required
              >
                <option value="">Select City</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-section-title">Current Address</div>
            
            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="sameAddress"
                  checked={sameAddress}
                  onChange={handleCheckboxChange}
                  className="styled-checkbox"
                />
                <label htmlFor="sameAddress">Same as permanent address</label>
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Address Line 1</label>
              <input
                className="form-control"
                type="text"
                value={address2}
                placeholder="Enter your house details"
                onChange={(e) => setAddress2(e.target.value)}
                disabled={sameAddress}
                required={!sameAddress}
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Address Line 2</label>
              <input
                className="form-control"
                type="text"
                value={address3}
                placeholder="Enter village or area name"
                onChange={(e) => setAddress3(e.target.value)}
                disabled={sameAddress}
                required={!sameAddress}
              />
            </div>

            <div className="form-row">
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">Country</label>
                  <select
                    className="form-control"
                    value={country1}
                    onChange={(e) => {
                      setCountry1(e.target.value);
                      handleCountryChange(e, true);
                    }}
                    disabled={sameAddress}
                    required={!sameAddress}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-col">
                <div className="form-group">
                  <label className="form-label">State</label>
                  <select
                    className="form-control"
                    value={state1}
                    onChange={(e) => {
                      setState1(e.target.value);
                      handleStateChange(e, true);
                    }}
                    disabled={sameAddress || !selectedCountry1}
                    required={!sameAddress}
                  >
                    <option value="">Select State</option>
                    {states1.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">City</label>
              <select
                className="form-control"
                value={city1}
                onChange={(e) => setCity1(e.target.value)}
                disabled={sameAddress || !selectedState1}
                required={!sameAddress}
              >
                <option value="">Select City</option>
                {cities1.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Form Footer */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn-secondary" 
              onClick={() => navigate("/modern-basic-info")}
            >
              Back
            </button>
            <button type="submit" className="btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernContactInfo;
